'use server'

import { revalidatePath } from 'next/cache'
import { cookies } from 'next/headers'

import { LOCALE_COOKIE } from '@/lib/locale'
import { LOCALES, type Locale } from '@/types/website'

/** Хэлний сонголтыг хадгалж, хуудсыг дахин үүсгэнэ. */
export async function setLocale(locale: Locale) {
  if (!LOCALES.includes(locale)) return

  const store = await cookies()

  store.set(LOCALE_COOKIE, locale, {
    path: '/',
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax'
  })

  revalidatePath('/', 'layout')
}
